import React, { useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

const Search = (props) => {
  const {
    id,
    name,
    label,
    options = [],
    placeholder,
    getOptionLabel = (opt) => opt?.label ?? "",
    defaultValue,
    multiple,
    value,
    disabled,
    handleOnChangeSearch,
    handleOnSelectSearchItem,
    isOptionEqualToValue,
    onClose,
    loading,
  } = props;

  const [searchInputText, setSearchInputText] = useState("");

  return (
    <Autocomplete
      id={id}
      name={name}
      options={options}
      loading={loading}
      value={value ?? null}
      getOptionLabel={getOptionLabel}
      defaultValue={defaultValue}
      multiple={multiple}
      disabled={disabled}
      isOptionEqualToValue={isOptionEqualToValue}
      fullWidth
      inputValue={searchInputText}
      renderInput={(params) => (
        <TextField {...params} label={label} placeholder={placeholder} />
      )}
      onClick={(e) => e.stopPropagation()}
      onFocus={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
      onChange={(event, newValue) => {
        handleOnSelectSearchItem?.(newValue);
      }}
      onClose={onClose}
      onInputChange={(event, newInputValue, reason) => {
        setSearchInputText(newInputValue);
        if (reason === "input") {
          handleOnChangeSearch?.(newInputValue);
        }
        if (reason === "clear") {
          handleOnSelectSearchItem?.(null);
        }
      }}
    />
  );
};

export default Search;
